import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {Patient} from '../../../model/user/Patient';
import {Q_HBI} from '../../../model/questionnaires/questionnaire-hbi';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {BackendApi, localhost} from '../../../config/backend-api';
import {QuestionnaireEvaluationComponent} from '../questionnaire-evaluation/questionnaire-evaluation.component';
import {HttpClient} from '@angular/common/http';
import {Store} from '@ngrx/store';
import {AppState} from '../../../store/app.states';
import {MatSnackBar} from '@angular/material/snack-bar';
import {doctorDispatching, EvaluationDTO} from '../utils';

export interface HBIDialogData {
  id: string;
  date: string;
  results: string[];
  complications: string[];
  finalScore: number;
  patientChosen: Patient;
  role: string;
  read: boolean;
  warning: boolean;
  evaluation: boolean;
}

@Component({
  selector: 'app-hbi-result-dialog',
  templateUrl: './hbi-result-dialog.component.html',
  styleUrls: ['./hbi-result-dialog.component.css']
})
export class HBIResultDialogComponent implements OnInit, OnDestroy {

  questions = Q_HBI;
  displayedColumns = ['position', 'question', 'value'];
  diagnosis: string;
  complications = [];

  read: boolean;
  warning: boolean;
  evaluation: boolean;

  constructor(public dialogRef: MatDialogRef<HBIResultDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: HBIDialogData,
              private httpClient: HttpClient,
              public dialog: MatDialog,
              private store: Store<AppState>,
              private snackBar: MatSnackBar) {
  }

  ngOnInit(): void {
    console.log(this.data.role);
    if (this.data.finalScore < 5) {
      this.diagnosis = 'Remissione';
    } else if (this.data.finalScore >= 5 && this.data.finalScore <= 7) {
      this.diagnosis = 'Attività lieve';
    } else if (this.data.finalScore >= 8 && this.data.finalScore <= 16) {
      this.diagnosis = 'Attività moderata';
    } else if (this.data.finalScore > 16) {
      this.diagnosis = 'Attività grave';
    }

    this.read = this.data.read;
    this.warning = this.data.warning;
    this.evaluation = this.data.evaluation;

    if (this.data.role === 'DOTTORE') {
      setTimeout(() => {
        this.read = true;
      }, 500);
    }

    this.data.complications.forEach(r => {
      const e = r.toLowerCase();
      this.complications.push(e);
    });
    console.log(this.complications);
  }

  evaluate() {
    if (this.data.role === 'DOTTORE') {
      this.dialog.open(QuestionnaireEvaluationComponent, {
        width: '500px',
        height: '290px',
        data: ['Ok', 'Segnala']
      }).afterClosed().subscribe(res => {
        if (res === undefined) {
          console.log(res);
        } else {

          const id = this.data.id.split('-');
          const date = id[0];
          const type = id[1];
          const doctorID = id[2];
          const patientSSN = id[3];

          let evaluation;

          if (res === 'Segnala') {
            // tslint:disable-next-line:max-line-length
            evaluation = new EvaluationDTO(date, false);
            this.evaluation = false;
            this.warning = true;

          } else if (res === 'Ok') {
            evaluation = new EvaluationDTO(date, true);
            this.evaluation = true;
            this.warning = false;
          }

          console.log('qua', type);

          // tslint:disable-next-line:max-line-length
          return this.httpClient.post(localhost +
            BackendApi.EVALUATE_QUESTIONNAIRE + type + '/' + doctorID + '/' + patientSSN,
            evaluation, {observe: 'response', responseType: 'text'})
            .subscribe(response => {
              if (response.status === 200) {
                if (this.data.role === 'DOTTORE') {
                  doctorDispatching(this.store, type, patientSSN);
                } else if (this.data.role === 'PAZIENTE') {
                  /*patientDispatching(this.patientService)*/
                }
                if (!evaluation.evaluation) {
                  window.location.href =
                    'mailto:' + this.data.patientChosen.email +
                    '?subject=IBD%20Tool%20-%20Segnalazione%20questionario%20HBI%20del%20' +
                    this.data.id.split('-')[0] + '&body=';
                  this.snackBar.open('Segnalazione effettuata correttamente.', 'Chiudi', {
                    duration: 2000
                  });
                } else {
                  this.snackBar.open('Valutazione effettuata correttamente.', 'Chiudi', {
                    duration: 2000
                  });
                }
              }
            });
        }
      });
    }
  }

  warn() {
    if (this.data.role === 'PAZIENTE') {
      const splitted = this.data.id.split('-');
      console.log(splitted);
      const date = splitted[0];
      const type = splitted[1];
      const doctorID = splitted[2];
      const patientSSN = splitted[3];
      // tslint:disable-next-line:max-line-length
      return this.httpClient.post(localhost + BackendApi.WARN_DOCTOR + type + '/' + doctorID + '/' + patientSSN, date, {observe: 'response', responseType: 'text'})
        .subscribe(res => {
          if (res.status === 200) {
            this.evaluation = false;
            this.warning = true;
            this.snackBar.open('Segnalazione effettuata correttamente.', 'Chiudi', {
              duration: 2000
            });
            // tslint:disable-next-line:max-line-length
            window.location.href = 'mailto:' + this.data.patientChosen.doctor.email + '?subject=IBD%20Tool%20-%20Segnalazione%20questionario%20HBI%20del%20' + date + '&body=';
          }
        });
    }
  }

  cancel() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    const id = this.data.id.split('-');
    console.log(id);
    let type = '';
    let patientSSN = '';
    if (id.includes('CLINICAL')) {
      type = id[1] + '-' + id[2];
      patientSSN = id[4];
    } else {
      type = id[1];
      patientSSN = id[3];
    }
    if (this.data.role === 'DOTTORE') {
      console.log(type, patientSSN);
      doctorDispatching(this.store, type, patientSSN);
    } else if (this.data.role === 'PAZIENTE') {
      /*patientDispatching(this.patientService)*/
    }
  }

}
